import { render } from "./headerSection.vue?vue&type=template&id=0ab8daa6&scoped=true"
import script from "./headerSection.vue?vue&type=script&lang=js"
export * from "./headerSection.vue?vue&type=script&lang=js"

import "./headerSection.vue?vue&type=style&index=0&id=0ab8daa6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ab8daa6"]])

export default __exports__